// Module
var code = "<div class=upload-container-logo><h3>Choose File</h3></div>";
// Exports
module.exports = code;